module.exports = __webpack_public_path__ + "img/profile_credential_006.0ba49591.png";